import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Platform } from '@ionic/angular';
import { AuthenticationService } from '../../authentication-service';
import { AuthenticationResult, SessionInfo } from '../../data/authentication-info';
import { MessageDisplayUtil } from '../../message-display-utils';
import { ConnectionService } from '../../providers/connection-service/connection-service';
import { AppState } from '../appstate';
import { createAction } from '../create-action';
import { PushNotificationActions } from '../pushnotf/pushnotfication-actions';
import { SessionDataService } from './session-data-service';
import { take } from 'rxjs/operators';
import { DiscountCompany } from 'src/data/mygolf.data';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
/**
 * Created by ashok on 10/05/17.
 */


@Injectable()
export class SessionActions {
    public static SHOW_LOGIN = 'LOGIN_FORM_SHOW';
    public static LOGIN = "LOGIN";
    public static LOGIN_SUCCESS = 'LOGIN_SUCCESS';
    public static PLAYER_LOGGED_IN = 'PLAYER_LOGGED_IN';
    public static ORGANIZER_LOGGED_IN = 'ORGANIZER_LOGGED_IN';
    public static CLUB_LOGGED_IN = 'CLUB_LOGGED_IN';
    public static ADMIN_LOGGED_IN = 'ADMIN_LOGGED_IN';
    public static LOGIN_FAILED = 'LOGIN_FAILED';
    public static CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';
    public static LOGOUT = 'LOGOUT';
    public static SET_PLAYER_ID = 'SET_SESSION_PLAYER_ID';
    public static UPDATE_PREFERENCE = 'UPDATE_PREFERENCE';
    public static SET_NEED_REFRESH = 'SET_NEED_REFRESH';
    public static CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';
    public appType: string;
    constructor(private store: Store<AppState>,
        private pushActions: PushNotificationActions,
        private sessionService: SessionDataService,
        private platform: Platform,
        private connService: ConnectionService,
        private authService: AuthenticationService,
        private flightService: ClubFlightService,
        private mg2uUtil: mygolfUtils
    ) {
    }

    public checkAndSignIn() {

        this.sessionService.getSession()
            .pipe(take(1))
            .subscribe((session: SessionInfo) => {
                if (session.authToken) {
                    // this.store.dispatch(createAction(SessionActions.LOGIN, {
                    //     userName: session.userName, password: session.password
                    // }));
                    this.loginSuccess(session);

                }
                else if (session.userName && session.password) {
                    this.login(session.userName, session.password);
                }
                else {
                    //You need to make sure that login form is shown
                    this.store.dispatch(createAction(SessionActions.SHOW_LOGIN));
                }

            });
    }
    /**
     * Initiatete the login
     * @param user
     * @param password
     */
    public login(user: string, password: string, appType?: string) {
        let _password = password;
        if (!appType) {
            appType = 'play';
        }
        if (!appType) appType = this.appType;
        if (appType) {
            this.appType = appType;
        }
        this.store.dispatch(createAction(SessionActions.LOGIN, {
            userName: user, password: password
        }));
        this.authService.authenticate(user, password, appType).subscribe((result: AuthenticationResult) => {
            if (result.success) {
                let newInfo: SessionInfo = {
                    authToken: result.authToken,
                    user: result.user,
                    userId: result.user.userId,
                    userName: result.user.userName,
                    password: result.user.password ? result.user.password : _password,
                    playerId: result.user.playerId,
                    clubId: result.user.clubId,
                    organizerId: result.user.organizerId,
                    userType: result.user.userType,
                    name: result.name,
                    admin: result.user.admin,
                    roles: result.user.roles,
                    caddieId: result.user.caddieId,
                    appType: appType,

                };
                if (result && !result.user.password) result.user.password = _password;
                if (result) result.appType = appType
                let _rolesPlayer = result.user.roles.filter((role) => {
                    if (role.toLowerCase() === 'role_player') return true
                });
                // let _rolesClub = result.user.roles.filter((role)=>
                //     if(role.toLowerCase() === 'role_club') return true
                // })


                let _noClub = true;
                let _superAdmin = false;
                if (appType === 'club') {
                    // && result.user.userType.toLowerCase() === 'Player'.toLowerCase()
                    // let _roles 
                    result.user.roles.filter((role) => {
                        if (role.toLowerCase().includes('role_club')) _noClub = false
                        else if (role.toLowerCase().includes('role_partner')) _noClub = false
                        else if (role.toLowerCase().includes('role_super_admin')) {
                            _noClub = false;
                            _superAdmin = true;
                        }
                        // else _noClub = false;
                    })



                    if (_noClub) {
                        this.loginFailed({
                            success: false,
                            exception: 'Could not sign-in with Player Id. Please use myGolf2u app (GREEN logo)'
                        })
                        return false;
                    } else {
                        if (!_superAdmin && !result.user.clubId && result && result.user && result.user.userType === 'Club') {
                            this.loginFailed({
                                success: false,
                                exception: 'The Club has not been activated by myGolf2u Admin. Please contact myGolf2u Admin for activation'
                            })
                            return false
                        }
                    }
                }
                else if (appType === 'play' &&
                    (result.user.userType.toLowerCase() === 'Club'.toLowerCase()
                        || result.user.userType.toLowerCase() === 'Organizer'.toLowerCase()
                        || result.user.userType.toLowerCase() === 'Partner'.toLowerCase()
                        || result.user.userType.toLowerCase() === 'Britesoft'.toLowerCase()
                    )) {
                    let _userType = result && result.user && result.user.userType ? result.user.userType : 'Non-Player'

                    if (_rolesPlayer && _rolesPlayer.length === 0 || !_rolesPlayer) {
                        this.loginFailed({
                            success: false,
                            exception: 'Could not sign-in with ' + _userType + ' Id. Please use myGolf2u Club App (BLUE logo)'
                        })
                        return false;
                    } else {
                        newInfo.userType = 'Player';
                        newInfo.user.userType = 'Player';

                        this.loginSuccess(newInfo, _rolesPlayer);
                        return false;
                    }
                }


                let _clubUserTypes = (result.user.userType.toLowerCase() === 'club'
                    || result.user.userType.toLowerCase() === 'caddy'
                    || result.user.userType.toLowerCase() === 'cashier')
                let _britesoft = result.user.userType.toLowerCase() === 'britesoft';
                if (appType === 'play' && result.user.userType.toLowerCase() === 'player') this.loginSuccess(newInfo, result.user.roles, appType);
                else if (appType === 'club' && (_clubUserTypes || !_noClub) && !_britesoft) this.loginSuccess(result, result.user.roles, appType);
                else if (appType === 'club' && _britesoft) this.loginSuccess(result, result.user.roles, appType);


            }
            else if (result && !result.success) {
                let msg = '';
                let _error: any = result;
                if (_error && _error.failureType) {
                    if (_error.failureType === 'InvalidCredentials') msg = 'You have entered an invalid password';
                    else if (_error.failureType === 'NotAClubMember') msg = 'You are not a member of this club';
                    else msg = _error.exception
                } else if (_error && !_error.failureType && _error.exception) msg = result.exception;
                else if (_error && _error.errorMessage) msg = _error.errorMessage;
                else msg = "Server may be down";
                if (_error && !_error.success) MessageDisplayUtil.getError(_error.exception, this.platform, this.connService, 'Server may be down.');
                else MessageDisplayUtil.getError("Server may be down", this.platform, this.connService, 'Server may be down.');

                this.loginFailed({
                    success: false,
                    exception: msg
                });
            } else {
                this.loginFailed(result);
            }
        }, (error) => {

            let msg = '';

            if (error) {
                let result: any = error;
                if (result.failureType) {
                    if (result.failureType === 'InvalidCredentials') msg = 'You have entered an invalid password';
                    else if (result.failureType === 'NotAClubMember') msg = 'You are not a member of this club';
                    else msg = result.exception
                } else if (!result.failureType && result.exception) msg = result.exception;
                else msg = result.errorMessage;
            }
            else {
                msg = 'Could not sign in. ' +
                    MessageDisplayUtil.getError(error, this.platform, this.connService, 'Server may be down.');
            }
            let _error = error.error;
            if (!_error.success) {
                if (_error.failureType) {
                    if (_error.failureType === 'InvalidCredentials') msg = 'You have entered an invalid password';
                    else if (_error.failureType === 'NotAClubMember') msg = 'You are not a member of this club';
                    else msg = _error.exception
                } else if (!_error.failureType && _error.exception) msg = _error.exception;
                else msg = _error.errorMessage;
                MessageDisplayUtil.getError(msg, this.platform, this.connService, 'Server may be down.');
            }
            if(_error?.status === 500) {
                if(_error?.error?.toLowerCase().includes('internal') && _error?.error?.toLowerCase().includes('error'))
                msg = "There was an error in the server. Please try again later"
            }
            if (!msg) msg = 'Server may be down'
            this.loginFailed({
                success: false,
                exception: msg
            });


        });


        // this.store.dispatch(createAction(SessionActions.LOGIN, {
        //     userName: user, password: password
        // }));
    }

    public loginSuccess(session: SessionInfo, roles?: Array<string>, appType?: string) {

        let _rolePlayer;
        if (roles) _rolePlayer = roles.filter((role) => {
            return role.toLowerCase() === 'role_player';
        });

        setTimeout(() => {
            if (session && session.user) {
                if (session.user && session.user.partnerId)
                    this._checkAndSetPartnerType(session.user.partnerId)
                else if (session && session.user.userType.toLowerCase() === 'britesoft') this.mg2uUtil.setUserType('britesoft');
                else this.mg2uUtil.setUserType(null);
            }
        }, 1000)



        this.store.dispatch(createAction(SessionActions.LOGIN_SUCCESS, session));
        switch (session.user.userType) {
            case 'Player':
                if (appType === 'play') this.store.dispatch(createAction(SessionActions.PLAYER_LOGGED_IN, session));
                else if (appType === 'club') this.store.dispatch(createAction(SessionActions.CLUB_LOGGED_IN, session));
                break;
            case 'Club':
                this.store.dispatch(createAction(SessionActions.CLUB_LOGGED_IN, session));
                break;
            case 'Organizer':
                if (_rolePlayer && _rolePlayer.length > 0) this.store.dispatch(createAction(SessionActions.PLAYER_LOGGED_IN, session));
                else this.store.dispatch(createAction(SessionActions.ORGANIZER_LOGGED_IN, session));
                break;
            case 'Admin':
                this.store.dispatch(createAction(SessionActions.ADMIN_LOGGED_IN, session));
                break;
            case 'Caddy':
                this.store.dispatch(createAction(SessionActions.CLUB_LOGGED_IN, session));
                break;
            case 'Britesoft':
                this.store.dispatch(createAction(SessionActions.ADMIN_LOGGED_IN, session));
                break;
        }


    }
    public loginFailed(authResult: AuthenticationResult) {

        this.store.dispatch(createAction(SessionActions.LOGIN_FAILED, authResult));
    }
    public clearLoginError() {
        this.store.dispatch(createAction(SessionActions.CLEAR_LOGIN_ERROR));
    }
    public logout() {
        this.authService.signout();
        this.store.dispatch(createAction(SessionActions.LOGOUT));
    }

    public updatePreference(session: SessionInfo) {
        this.store.dispatch(createAction(SessionActions.UPDATE_PREFERENCE, session))
    }

    private _checkAndSetPartnerType(partnerId: string) {

        this.flightService.getPartnerDetails(partnerId)
            .subscribe((data: DiscountCompany) => {

                if (data) {
                    if (data.partnerServices) {
                        data.partnerServices.filter((service) => {
                            return service.toLowerCase().includes('booking_agent')
                        }).map((service) => {
                            this.mg2uUtil.setUserType('booking_agent');
                            this.mg2uUtil.setPartnerInfo(data);
                        })
                    }
                }
                // this.mg2uUtil.setUserType
            })
    }

    public setNeedRefresh(value: boolean) {
        this.store.dispatch(createAction(SessionActions.SET_NEED_REFRESH, value));
    }
    public clearAllStates() {
        this.store.dispatch(createAction(SessionActions.CLEAR_ALL_STATES));
    }
}